const Flag = () => {
    return (<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1V2.5M1 2.5L3.77 1.807C5.8544 1.28605 8.05641 1.52795 9.978 2.489L10.086 2.543C11.9688 3.4843 14.1219 3.73589 16.171 3.254L19.281 2.522C18.9029 6.01155 18.9046 9.53181 19.286 13.021L16.172 13.753C14.1227 14.2354 11.9692 13.9842 10.086 13.043L9.978 12.989C8.05641 12.028 5.8544 11.786 3.77 12.307L1 13M1 2.5V13M1 19V13"
            // stroke="#4B5563"
            stroke="currentColor"
            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>)
}

export default Flag;
